export default __webpack_public_path__ + "static/media/cp_geo_sr.5a345f8e.svg";